import { initializeSdk } from '@eventbrite/statsig';
import { AppProps, StatsigProps } from './types';

export const getCustomUserIDfromExperimentCookie = () => {
    const cookieValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith('allow_experiments_cookie='))
        ?.split('=')[1];
    return cookieValue;
};

export const checkGateFromServer = (
    gateName: string,
    statsigProps?: StatsigProps,
): Boolean =>
    statsigProps?.feature_gates?.hasOwnProperty(gateName)
        ? statsigProps.feature_gates[gateName]
        : false;

export const initializeStatsigSdk = async (app: AppProps) => {
    const customID = getCustomUserIDfromExperimentCookie();
    await initializeSdk({
        user: {
            userID: customID,
            custom: {
                eventId: app.event?.id,
                organizerId: app.organizer?.id,
                customID,
            },
        },
    });
};
